import * as actionTypes from 'actions';

const initialState = {
  pageNumber: 1,
  rowCount: 0,
  loading: false,
  items: [],
  pageSize: 250,
  filterItemCount: null,
  filter: {
    search: ''
  },
  selectedPackageIds: []
};

const PAGE = 'SOFTWARE_PACKAGE_LIST';

const softwarePackageListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SOFTWARE_PACKAGE_PAGINATED_LIST_PENDING: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.SOFTWARE_PACKAGE_PAGINATED_LIST_FULFILLED: {
      return {
        ...state,
        ...action.payload.data.result,
        filter: {
          ...initialState.filter,
          ...action.payload.data.result.filter
        },
        selectedPackageIds: initialState.selectedPackageIds,
        loading: false
      };
    }

    case actionTypes.UPDATE_SOFTWARE_PACKAGE_STATUSES: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.SELECT_SOFTWARE_PACKAGE_LIST_PACKAGE: {
      const packageId = action.payload;
      const packageIds = state.selectedPackageIds.slice();
      const packageIdIndex = packageIds.indexOf(packageId);

      if (packageIdIndex !== -1) {
        packageIds.splice(packageIdIndex, 1);
      } else {
        packageIds.push(packageId);
      }

      return {
        ...state,
        selectedPackageIds: packageIds
      };
    }

    case actionTypes.SET_FILTER_VALUE: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          filter: {
            ...state.filter,
            ...action.payload.value
          }
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.SET_PAGE_SIZE: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          pageSize: action.payload.pageSize
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.CLEAR_FILTER_VALUES: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          filter: {
            ...initialState.filter,
            search: state.filter.search
          },
          filterItemCount: initialState.filterItemCount
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.GET_FILTER_VALUES_FULFILLED: {
      let result;
      if (
        action.payload.data.result &&
        action.payload.data.result.page === PAGE
      ) {
        result = {
          ...state,
          filterItemCount: action.payload.data.result.filter.filterItemCount,
          filter: {
            ...initialState.filter,
            ...action.payload.data.result.filter
          }
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    default: {
      return state;
    }
  }
};

export default softwarePackageListReducer;
